import { render, staticRenderFns } from "./fluidLayout.vue?vue&type=template&id=5e7d3f33"
import script from "./fluidLayout.vue?vue&type=script&lang=ts"
export * from "./fluidLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports